import styled from "styled-components";
import { Link } from "react-router-dom";
import { siteDarkBlue, siteDarkGreen } from "../../providers/Theme";
import { bodyFontBase, buttonFontSize } from "../shared.styled.components";

export const PageSection = styled.section`
  background: white;
  padding: 3rem 2rem 5rem;
`;

export const PageInner = styled.div`
  max-width: 72rem;
  margin: 0 auto;
`;

export const PageHeading = styled.h1<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-weight: 800;
  font-size: 2rem;
  margin-bottom: 0.75rem;

  ${({ theme }) => theme.md`
    font-size: 2.4rem;
  `}
`;

export const PageSubtitle = styled.p`
  color: ${siteDarkBlue};
  font-size: ${bodyFontBase};
  line-height: 1.7;
  margin-bottom: 2.5rem;
  max-width: 56rem;
`;

export const MembersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;

  ${({ theme }) => theme.md`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${({ theme }) => theme.lg`
    grid-template-columns: repeat(3, 1fr);
  `}
`;

export const BackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: ${siteDarkGreen};
  color: white;
  font-weight: 700;
  font-size: ${buttonFontSize};
  text-decoration: none;
  border-radius: 0.6rem;
  padding: 0.85rem 2rem;
  margin-top: 3rem;
  transition: filter 0.15s ease;

  &:hover {
    filter: brightness(0.9);
    color: white;
  }
`;
